import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeaturesService } from './features.service';

/**
 * Guard that checks if labs feature is enabled for the current organization
 * @returns A promise that resolves to true if labs are enabled, false otherwise
 */
export const featureGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
) => {
    const feature = route.data['feature'];
    if (!feature) {
      return Promise.resolve(false);
    }

    const featureService = inject(FeaturesService);
    return featureService.isEnabled(feature);
};
